import Vue from 'vue'
import VueRouter from 'vue-router'
import Root from '@/components/Root'

import Home from "../components/Home/Home";
import AboutUs from "../components/AboutUs/AboutUs";
import Product from "../components/Product/Product";
import Game from "../components/Game/Game"
import Poker from "../components/Game/detail/Poker"
import Arcadia from "../components/Game/Arcadia"
import minigame from "../components/Game/detail/minigame"
import marblegame from "../components/Game/detail/marblegame"
import lottogame from "../components/Game/detail/lottogame"
import aresbetgame from "../components/Game/detail/aresbetgame"
import aeonbetgame from "../components/Game/detail/aeonbetgame"
import demo from "../components/Game/demo"

Vue.use(VueRouter);

const routes = [
  {
    path: '/demo/:type/:width/:height/:device/:gameCode/:uId/:uiType/:lang',
    name: 'demo',
    component: demo
  },
  {
    path: '/',
    name: 'Root',
    component: Root,
    children: [
      {
        path: '/',
        name: 'Home',
        component: AboutUs
      },
      {
        path: '/product',
        name: 'Product',
        component: Product
      },
      {
        path: 'aboutus',
        name: 'AboutUs',
        component: AboutUs
      },
      {
        path: 'game',
        name: 'Game',
        component: Game,
        children: [
          {
            path: 'poker',
            name: 'poker',
            component: Poker
          },
          {
            path: 'minigame/:game',
            name: 'minigame',
            component: minigame
          },
          {
            path: 'marblegame/:game',
            name: 'marblegame',
            component: marblegame
          },
          {
            path: 'lottogame/:game',
            name: 'lottogame',
            component: lottogame
          },
          {
            path: 'aresbetgame/:game',
            name: 'aresbetgame',
            component: aresbetgame
          },
          {
            path: 'aeonbetgame/:game',
            name: 'aeonbetgame',
            component: aeonbetgame
          },
        ]
      },
    ]
  },

];

const router = new VueRouter({
  routes
});

export default router
